var map = {
	"./Amal Samji.jpg": 398,
	"./Bhavin Patel.jpg": 399,
	"./Jay Desor.jpg": 400,
	"./Jay Shah.jpg": 401,
	"./Juj Sandhu.jpg": 402,
	"./Navin Bharwani.jpg": 403,
	"./Safina Siddiqui.jpg": 404,
	"./Surabhi Prasad.jpg": 405,
	"./Vaidehi Naik.jpg": 406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;